<div [appStoryblok]="_editable()" class="row" data-rr-shared="true">
  @for (spot of spots; track spot.originalObj._uid) {
    @if (spot) {
      <app-storyblok-spot [appStoryblok]="spot._editable" [class]="spot.col"
                          [spot]="spot.spot"></app-storyblok-spot>
    }
  }
</div>
